import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/contexts/AuthContext";
import { History, ArrowRight } from "lucide-react";

const fmtVal = (v) => {
  if (v === null || v === undefined || v === "") return "(vazio)";
  if (typeof v === "number") return v.toLocaleString("pt-BR", { maximumFractionDigits: 4 });
  return String(v);
};

export const BalanceEntryHistory = ({ entryId }) => {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    if (!entryId) return;
    setLogs(null);
    axios.get(`${API}/balance/entries/${entryId}/history`, { withCredentials: true })
      .then(({ data }) => setLogs(data)).catch(() => setLogs([]));
  }, [entryId]);

  return (
    <div className="space-y-2" data-testid="balance-view-history">
      <p className="text-[11px] uppercase tracking-wider text-muted-foreground flex items-center gap-1">
        <History className="h-3.5 w-3.5" /> Historico de Alteracoes
      </p>
      {logs === null ? (
        <p className="text-sm text-muted-foreground">Carregando...</p>
      ) : logs.length === 0 ? (
        <p className="text-sm text-muted-foreground" data-testid="balance-view-history-empty">
          Nenhuma alteracao registrada (o historico e gravado a partir desta versao).
        </p>
      ) : (
        <ol className="border-l-2 border-border ml-1.5 space-y-3">
          {logs.map((l) => (
            <li key={l.id} className="pl-4 relative" data-testid={`balance-history-item-${l.id}`}>
              <span className={`absolute -left-[5px] top-1.5 h-2 w-2 rounded-full ${l.action === "balance_update" ? "bg-amber-500" : "bg-emerald-500"}`} />
              <p className="text-sm">
                <span className="font-semibold">{l.user_name || l.username || "-"}</span>
                <span className="text-muted-foreground"> · {new Date(l.created_at).toLocaleString("pt-BR")} · </span>
                {l.action === "balance_update" ? "alterou" : (l.details || "criou")}
              </p>
              {(l.changes || []).length > 0 && (
                <ul className="mt-1 space-y-0.5">
                  {l.changes.map((c, i) => (
                    <li key={i} className="text-xs flex flex-wrap items-center gap-1">
                      <span className="font-medium">{c.field}:</span>
                      <span className="line-through text-red-600">{fmtVal(c.old)}</span>
                      <ArrowRight className="h-3 w-3 text-muted-foreground" />
                      <span className="text-emerald-700 font-medium">{fmtVal(c.new)}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
